import { UserManagementForm } from "@redux/reducers/userManagementReducer";

export enum ActionType {
  USER_MANAGEMENT_DETAIL_BY_PID = "USER_MANAGEMENT_DETAIL_BY_PID",
}
export interface IUserManagementByPid {
  type: ActionType.USER_MANAGEMENT_DETAIL_BY_PID;
  payload: UserManagementForm[];
}

export type Action = IUserManagementByPid;
